// src/components/Assistant.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';
import Chat from './Chat';
import ThreadList from './ThreadList';
import ModulesList from './ModulesList'; // Import ModulesList

const Assistant = () => {
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [currentThread, setCurrentThread] = useState(null);
  const [isThreadPanelOpen, setIsThreadPanelOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
          setUser(session.user);
        } else {
          navigate('/');
        }
      } catch (error) {
        console.error('Error fetching user:', error);
      } finally {
        setLoadingUser(false);
      }
    };
    fetchUser();
  }, [navigate]);

  const toggleThreadPanel = () => {
    setIsThreadPanelOpen(prev => !prev);
  };

  if (loadingUser) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <p className="text-gray-600">Loading Assistant...</p>
      </div>
    );
  }

  return (
    <div className="relative flex flex-col bg-gray-50 min-h-screen">
      {/* Mobile Top Bar */}
      <div className="md:hidden flex justify-between items-center p-4 bg-white border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-700">Assistant</h2>
        <button
          onClick={toggleThreadPanel}
          className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
        >
          {isThreadPanelOpen ? 'Close Threads' : 'Open Threads'}
        </button>
      </div>

      <div className="flex flex-1">
        {/* Desktop Thread Sidebar */}
        <div className="hidden md:block w-80 border-r border-gray-200">
          <ThreadList
            user={user}
            currentThread={currentThread}
            setCurrentThread={setCurrentThread}
          />
        </div>

        {/* Main Chat Area */}
        <div className="flex-1 overflow-y-auto">
          <Chat
            user={user}
            currentThread={currentThread}
            setCurrentThread={setCurrentThread}
            threadName={currentThread ? currentThread.name : 'No Thread Selected'}
          />
         

        </div>
      </div>

      {/* Mobile Slide-Over Thread Panel */}
      <div
        className={`fixed inset-y-0 left-0 w-80 bg-white border-r border-gray-200 z-50 transform transition-transform duration-300
          ${isThreadPanelOpen ? 'translate-x-0' : '-translate-x-full'} md:hidden`}
      >
        <div className="p-4 border-b border-gray-200 flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-700">Threads</h3>
          <button
            onClick={toggleThreadPanel}
            className="text-gray-600 hover:text-gray-800"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <ThreadList
          user={user}
          currentThread={currentThread}
          setCurrentThread={(thread) => {
            setCurrentThread(thread);
            setIsThreadPanelOpen(false); // close after selecting a thread on mobile
          }}
        />
      </div>

      {/* Mobile Backdrop */}
      {isThreadPanelOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-40 md:hidden"
          onClick={toggleThreadPanel}
        />
      )}
    </div>
  );
};

export default Assistant;
